var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.faqs)?_c(_vm.modules.Faqs,{tag:"component",staticClass:"faqs--standalone",attrs:{"faqs":_vm.isArray}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }